/**
 * API Error type definition for type-safe error handling
 */
export interface ApiError {
  status?: number;
  code?: string;
  message?: string;
  response?: {
    status: number;
    data?: {
      message?: string;
      errors?: Record<string, string[]>;
    };
  };
}

/**
 * Type guard to check if an unknown error is an ApiError
 */
export function isApiError(error: unknown): error is ApiError {
  return typeof error === 'object' && error !== null && ('status' in error || 'response' in error || 'code' in error);
}

/**
 * Get status code from an unknown error
 */
export function getErrorStatus(error: unknown): number | undefined {
  if (!isApiError(error)) return undefined;
  return error.status ?? error.response?.status;
}
